import styled from "styled-components";
import { Text } from "@gcs/design-system/react";

const flexColumn = {
  display: "flex",
  flexDirection: "column",
};

export const AchievementsStampContainer = styled.section(({ theme }) => ({
  paddingTop: "40px",
  paddingBottom: "40px",

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const AchievementsStampContent = styled.div(() => ({
  ...flexColumn,
  gap: "60px",
}));

export const AchievementsStampHeader = styled.div(() => ({
  ...flexColumn,
  gap: "12px",
}));

export const AchievementsStampTitle = styled.h2(({ theme }) => ({
  fontSize: "28px",
  fontWeight: "700",
  lineHeight: "150%",
  margin: 0,
  color: theme.color.neutral["02"],

  [theme.breakpoint.lg()]: {
    fontSize: "32px",
  },
}));

export const AchievementsStampDescription = styled(Text)(() => ({
  margin: 0,
  fontWeight: "500",
}));

export const AchievementsStampList = styled.div(({ theme }) => ({
  ...flexColumn,
  gap: "40px",

  [theme.breakpoint.lg()]: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "40px 32px",
  },

  svg: {
    maxWidth: "250px",
  },
}));

export const AchievementsStampItem = styled.div(({ theme }) => ({
  ...flexColumn,
  gap: "10px",

  maxWidth: "100%",
  width: "100%",
  borderLeft: `1px solid ${theme.color.line.medium}`,
  paddingLeft: "32px",
}));

export const AchievementsStampImage = styled.div(() => ({
  justifySelf: "flex-start",

  svg: {
    height: "120px",
  },
}));

export const AchievementsStampBlock = styled.div(() => ({
  ...flexColumn,
  gap: "12px",
}));

export const AchievementsStampItemTitle = styled.h2(({ theme }) => ({
  fontSize: "20px",
  fontWeight: "700",
  color: theme.color.brandPrimary.light,
  margin: 0,
  lineHeight: "1",

  [theme.breakpoint.lg()]: {
    fontSize: "24px",
  },
}));

export const AchievementsStampItemDescription = styled(Text)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: "500",
  color: theme.color.neutral["02"],
  padding: 0,
  margin: 0,

  [theme.breakpoint.lg()]: {
    fontSize: "18px",
  },
}));
